<script>
import commomUtils from '@/mixins/common-utils.js'
import { zendeskActions } from '@state/helpers'
import SubHeader from '@components/sub-header'
import { mapGetters } from 'vuex'

export default {
  name: 'SolutionTypeList',
  components: {
    SubHeader,
  },
  mixins: [commomUtils()],
  props: {
    componentData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      tags: [],
      selectedtem: '',
    }
  },
  computed: {
    ...mapGetters('widgets', ['notSatisfiedUser']),
    countryCode() {
      return this.$route.query.country_code
    },
  },
  watch: {
    selectedtem() {
      this.commitCustomField({
        value: this.selectedtem,
        // id: this.componentData.customFieldId,
        key: this.componentData.key ? this.componentData.key : 'solution_type',
      })
      this.commitZendeskCommon({
        key: this.componentData.key ? this.componentData.key : 'solution_type',
        data: {
          title: this.componentData.title,
          value: this.selectedtem,
        },
      })
    },
  },
  created() {
    this.selectedtem = this.componentData.values[0].id
  },
  methods: {
    ...zendeskActions,
    getselectedtem: function() {
      return this.selectedtem
    },
  },
}
</script>

<template>
  <div
    v-if="notSatisfiedUser"
    :class="$style.container"
  >
    <SubHeader :text="componentData.title || $t('WIDGETS.OPTION_LIST.TITLE')"/>

    <div>
      <BaseRadio
        v-for="v in componentData.values"
        :class="$style.container__radios"
        :key="v.id"
        :value="v.id"
        v-model="selectedtem"
        :label="v.value"
      />
    </div>
  </div>
</template>

<style lang="scss" module scoped>
@import '@design';

.container {
  padding-top: 1.2rem;
  margin: $size-spacing-medium 0;
  text-align: left !important;
  background-color: white;

  &__radios {
    @extend %typography-medium;

    display: flex;
    justify-content: space-between;
    width: 100%;
    padding: 1rem;
    color: $slate-grey;

    &:not(:last-child) {
      border-bottom: 1px solid $divider-gray;
    }
  }
}
</style>
